module.exports = __webpack_public_path__ + "img/SQL定义统计.f5a97e25.svg";